import {
  compose,
  createStore,
  applyMiddleware,
} from 'redux';
import ReduxThunk from 'redux-thunk';
import boardScopeMiddleware from './board/scopeMiddleware';
import {
  loadPlannerUiState,
  savePlannerUiState,
} from './planner/storage';
import rootReducer from './reducer';

export default (preloadedState) => {
  const plannerUiState = loadPlannerUiState();
  const resolvedPreloadedState = plannerUiState
    ? {
      ...preloadedState,
      planner: { ...plannerUiState },
    }
    : preloadedState;

  const store = createStore(
    rootReducer,
    resolvedPreloadedState,
    compose(
      applyMiddleware(boardScopeMiddleware, ReduxThunk),
      window.__REDUX_DEVTOOLS_EXTENSION__ //eslint-disable-line
        ? window.__REDUX_DEVTOOLS_EXTENSION__() //eslint-disable-line
        : (f) => f,
    ),
  );

  store.subscribe(() => {
    savePlannerUiState(store.getState().planner);
  });

  return store;
};
